import React from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';


import { formattedNumber } from '../../../../../utils/formatterHelpers';
import '../../../../../grid.css';
import './monthlyloan.css';

class MonthlyLoan extends React.Component {
    static propTypes = {
        annualResults: PropTypes.object.isRequired,
        setMosaicTerm: PropTypes.func.isRequired,
        loanProvider: PropTypes.string.isRequired,
        projectState: PropTypes.number.isRequired,
        loanTerm: PropTypes.number.isRequired,
        mosaicTerm: PropTypes.number.isRequired,
        selectedFinancing: PropTypes.number.isRequired,
        resiToggle: PropTypes.bool.isRequired,
    };

    handleMosaicTermChange(value) {
        const { setMosaicTerm } = this.props;
        setMosaicTerm(value);
    }

    render() {
        const {
            annualResults,
            loanProvider,
            mosaicTerm,
            loanTerm,
            projectState,
            resiToggle,
            selectedFinancing,
        } = this.props;

        let financeTerm = loanTerm;
        if (loanProvider === 'mosaic') {
            financeTerm = mosaicTerm;
        }

        const monthlyMosaicPayment = annualResults[3].annualHomeLoanPayment / 12;


        let avgMonthlyIncentives =
            annualResults[financeTerm / 12].cumulativeIncentives / financeTerm;
        if (projectState === 4) {
            avgMonthlyIncentives = 0;
        }
        let afterIncentive = 'net incentive';
        if (projectState === 2) {
            afterIncentive = 'net SMART';
        }
        if (projectState === '3') {
            afterIncentive = 'net RECS';
        }

        const monthlyUtility = annualResults[1].annualSolarSavings / 12;

        const netMonthlyMosaic = (
            annualResults[3].annualHomeLoanPayment / 12) - avgMonthlyIncentives;

        const netMonthlyCustomLoan = (
            annualResults[3].loanPayment / 12) - avgMonthlyIncentives;

        const savingsPercentMonth =
        100 - (formattedNumber(netMonthlyMosaic / monthlyUtility * 100));

        let incentive = 'Incentives';
        if (projectState === 1) {
            incentive = 'SGIP';
        }
        if (projectState === 2) {
            incentive = 'SMART';
        }
        if (projectState === '3') {
            incentive = 'RECs';
        }

        let pay = 'pay';
        if (projectState === 1 || projectState === 2) {
            pay = 'pays';
        }

        let loanSavings = null;
        if (selectedFinancing === 2 && loanProvider === 'mosaic') {
            loanSavings =
            formattedNumber(annualResults[30].cumulativeMosaicSavings);
        } else if (selectedFinancing === 2 && loanProvider === 'custom') {
            loanSavings =
            formattedNumber(annualResults[30].cumulativeLoanSavings);
        }

        return (
            <Paper className="monthlyVS">
                <h1>Monthly Solar Outlook</h1>
                <div className="row">
                    <div className="col span-1-of-3">
                        <div className="utilPayment">
                            ${formattedNumber(monthlyUtility)} per month
                        </div>
                        <div>
                            <p className="smGrtxt">existing bill</p>
                        </div>
                    </div>
                    <div className="col span-1-of-3">
                        <h1>VS.</h1>
                    </div>
                    <div className="col span-1-of-3">
                        {loanProvider === 'mosaic' ?
                            <div className="netPayment">
                                ${formattedNumber(netMonthlyMosaic)} per month
                                <p className="smGrtxt">Mosaic Payment {afterIncentive}</p>
                            </div> : null }
                        {loanProvider === 'custom' ?
                            <div className="netPayment">
                                ${formattedNumber(netMonthlyCustomLoan)} per month
                                <p className="smGrtxt">Loan Payment {afterIncentive}</p>
                            </div> : null }

                    </div>
                </div>
                {resiToggle && projectState === 4 ?
                    <div className="row">
                        <p>You have to buy electricity, our way is better.
                        </p>
                    </div>
                    : null }
                {resiToggle && projectState !== 4 ?
                    <div className="row">
                        <p>{incentive} {pay} for &nbsp;
                            {(formattedNumber(avgMonthlyIncentives / monthlyMosaicPayment * 100))}%
                            of your Mosaic payment!
                        </p>
                    </div>
                    : null }
                {loanProvider === 'mosaic' ?
                    <div>
                        {savingsPercentMonth > 0 ?
                            <p>{savingsPercentMonth}% savings each month and you own solar... </p>
                            : null}
                        <p className="totalSavings"> Total Savings:
                            ${loanSavings}
                        </p>
                    </div>
                    : null }
            </Paper>
        );
    }
}

export default MonthlyLoan;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/MonthlyLoan/MonthlyLoan.js